interface IconProps {
  color?: string
  width?: number
  height?: number
}
export default function LootTabIcon({ color = 'white', width = 30, height = 30 }: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.08274" y="2.75803" width="26.8341" height="26.8341" stroke={color} strokeWidth="3.83344" />
      <rect x="9.74973" y="10.424" width="11.5003" height="11.5003" stroke={color} strokeWidth="3.83344" />
      <path d="M29.2998 2.37451L24.6997 6.97464" stroke={color} strokeWidth="3.83344" />
      <path d="M1.69922 29.9751L6.29935 25.375" stroke={color} strokeWidth="3.83344" />
      <path d="M1.69922 2.37451L6.29935 6.97464" stroke={color} strokeWidth="3.83344" />
      <path d="M29.2998 29.9751L24.6997 25.375" stroke={color} strokeWidth="3.83344" />
    </svg>
  )
}
